// extracted by mini-css-extract-plugin
export default {"body":"ingredients_body__HBSS1","conteiner":"ingredients_conteiner__cGm28","img":"ingredients_img__hUuDz"};